import { type ApiRequestService } from '@coris-ts/repository/data-source/api-request.service'
import { Cached } from '@coris-ts/helpers/utilities'
import { GetRepositoryMapper } from '@coris-ts/repository/repository-mapper'
import { provideDefaultNetworkDataSource } from '@coris-ts/repository/data-source/network.data-source'
import { SingleGetDataSourceRepository } from '@coris-ts/repository/single-data-source.repository'
import { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { SubscriberPageEntity, SubscriberFiltersEntity } from './data/entities/subscriber.entity'
import { GetSubscribersInteractor } from './domain/interactors/get-subscribers.interactor'
import { GetSubscriberFiltersInteractor } from './domain/interactors/get-subscriber-filters.interactor'

export interface SubscribersComponent {
  provideGetSubscribers: () => GetSubscribersInteractor
  provideGetSubscriberFilters: () => GetSubscriberFiltersInteractor
}

export class SubscribersDefaultModule implements SubscribersComponent {
  constructor(private readonly apiRequestService: ApiRequestService) {}

  @Cached()
  private getSubscribersRepository(): GetRepositoryMapper<SubscriberPageEntity, SubscriberPageEntity> {
    const dataSource = provideDefaultNetworkDataSource(this.apiRequestService, SubscriberPageEntity)
    const repository = new SingleGetDataSourceRepository(dataSource)
    return new GetRepositoryMapper(repository, { map: (entity: SubscriberPageEntity) => entity })
  }

  @Cached()
  private getSubscriberFiltersRepository(): GetRepositoryMapper<SubscriberFiltersEntity, SubscriberFiltersEntity> {
    const dataSource = provideDefaultNetworkDataSource(this.apiRequestService, SubscriberFiltersEntity)
    const repository = new SingleGetDataSourceRepository(dataSource)
    return new GetRepositoryMapper(repository, { map: (entity: SubscriberFiltersEntity) => entity })
  }

  public provideGetSubscribers(): GetSubscribersInteractor {
    return new GetSubscribersInteractor(new GetInteractor<SubscriberPageEntity>(this.getSubscribersRepository()))
  }

  public provideGetSubscriberFilters(): GetSubscriberFiltersInteractor {
    return new GetSubscriberFiltersInteractor(
      new GetInteractor<SubscriberFiltersEntity>(this.getSubscriberFiltersRepository())
    )
  }
}
